import React, { useMemo } from 'react';
import { appConst } from '../../../app-const';
import DataGrid, {
    Column,
    ColumnFixing,
    ColumnChooser,
    FilterPanel,
    FilterRow,
    HeaderFilter,
    Lookup,
    Pager,
    Paging,
    Selection,
    Sorting
} from 'devextreme-react/data-grid';
import { useCommonContext } from '../../../contexts/common';
// import './detail-form-register.css'
const formEditorFixeds = Object.values(appConst.formEditorFixed)

const DetailGrid = ({ grid, ts_form_items, dataSource, dm_chiendichs, btnEdit_click, onSelectionChanged, selectedRowKeys, btnNewHS_click, viewMaHs }) => {
    const { translate } = useCommonContext();
    const dynamicColumns = useMemo(() => {
        return ts_form_items.map((x) => {
            return (
                <Column
                    key={x.id}
                    dataField={`TC_${x.ts_form_editor_id}`}
                    caption={x.label}
                    width={150}
                ></Column>
            );
        })

    }, [ts_form_items])

    const cellRender = (data) => {
        // console.log(data, 'data')
        return (
            <div style={{ textAlign: "left" }}>
                <span style={{ color: data.data.ts_hocsinh_id > 0 ? "#3caa62" : "" }}>
                    {data.data.ts_hocsinh_id > 0 ? "Đã cập nhật" : "Chưa cập nhật"}
                </span>
            </div>
        );
    };

    const cellUpdate = (data) => {
        return (
            <div>
                {data.data.ts_hocsinh_id <= 0 && (<span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        btnEdit_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="icon edit"></i>{' '}
                </span>
                )}
                {data.data.ts_hocsinh_id <= 0 && (<span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        btnNewHS_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="icon add"></i>{' '}
                </span>
                )}
            </div>
        );
    }

    const cellRenderUpdate = (data) => {
        // console.log(data, 'data')
        return (
            <div style={{ textAlign: "left" }}>
                <span style={{ color: data.data.is_update_invite ? "#3caa62" : "" }}>
                    {data.data.is_update_invite ? "Đã tham gia" : "Chưa tham gia"}
                </span>
            </div>
        );
    };



    return (
        <div>
            <DataGrid
                keyExpr="id"
                ref={grid}
                dataSource={dataSource}
                columnHidingEnabled={false}
                columnAutoWidth={true}
                showBorders={true}
                showColumnLines={true}
                // allowColumnReordering={true}
                showRowLines={false}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={'nextColumn'}
                hoverStateEnabled={true}
                focusedRowEnabled={false}
                height={window.innerHeight - 240}
                className="table-noborder-left table-detail-grid"
                noDataText={translate('Không có dữ liệu')}
                wordWrapEnabled

                // selectedRowKeys={selectedRowKeys}
                onSelectionChanged={(e) => {
                    const { selectedRowKeys } = e;
                    onSelectionChanged(selectedRowKeys)
                    // dispatch({ type: phuHuynhActionTypes.CHANGE_SELECTED_IDS, payload: selectedRowKeys })
                }}
            >
                <Selection mode="multiple" showCheckBoxesMode="always" />
                {/* <ColumnChooser enabled={true} /> */}
                <ColumnFixing enabled={true} />
                <Column fixed={true} caption={'#'} width={70} alignment="center" cellRender={(cell) => {
                    return <span>{cell.rowIndex + 1}</span>
                }}></Column>
                <Column fixed={true} key={0} cellRender={cellUpdate} alignment="center" caption={translate('Thao tác')} width={80} ></Column>,
                <Column fixed={true} caption={translate('Tư vấn viên')} alignment="center">
                    <Column dataField="tu_van_vien_bo" caption={translate('Bố')} width={150}></Column>
                    <Column dataField="tu_van_vien_me" caption={translate('Mẹ')} width={150}></Column>
                </Column>
                <Column fixed={true} dataField="dm_chiendich_id" caption={translate('Chiến dịch')} width={200}>
                    <Lookup dataSource={dm_chiendichs} valueExpr="id" displayExpr={"ten_chien_dich"} />
                </Column>
                {/* <Column dataField="phone_number" caption={translate('Điện thoại')} width={100}></Column>
                <Column dataField="ho_ten" caption={translate('Họ tên')} width={150}></Column>
                <Column dataField="email" caption={translate('Email')} width={150}></Column>
                <Column dataField="ho_ten_hoc_sinh" caption={translate('Học sinh')} width={150}></Column>
                <Column dataField="khoi_lop" caption={translate('Khối')} width={100}>
                </Column>
                <Column dataField="ghi_chu" caption={translate('Ghi chú')} width={120}></Column> */}
                <Column fixed={true} dataField="register_date" dataType="date" format="dd/MM/yyyy HH:mm" caption={translate('Ngày ĐK')} width={130}></Column>
                <Column dataField="ts_hocsinh_id" cellRender={cellRender} caption={translate('Cập nhật học sinh')} width={120}></Column>
                <Column dataField="is_update_invite" cellRender={cellRenderUpdate} caption={translate('Tham gia hội thảo')} width={120}></Column>
                {viewMaHs &&
                    <Column dataField="ma_hs" caption={translate('Mã học sinh')} width={120}></Column>
                }
                {dynamicColumns.length > 0 && dynamicColumns}
                {/* <Column caption={"Data khác"} alignment="center">
                        {dynamicColumns}
                    </Column> */}
                {/* } */}
                {/* <Column caption={"Kết quả"} alignment="center">
                    <Column dataField="is_attendanced" caption={translate('Điểm danh')} dataType="boolean" width={120}></Column>
                    <Column dataField="register_date" dataType="date" format="dd/MM/yyyy" caption={translate('Ngày ĐK')} width={100}></Column>
                    <Column dataField="ket_qua_tra_chieu" caption={translate('Trà chiều')} width={150}></Column>
                    <Column dataField="is_send_mail_result" caption={translate('Email kết quả')} width={130}></Column>
                     <Column caption={translate('Email mời hội thảo')} alignment="center">
                        <Column dataField="is_send_mail_invite" caption={translate('Đã gửi')} width={160}></Column>
                        <Column dataField="send_mail_invite_at" dataType="date" format="dd/MM/yyyy HH:mm" caption={translate('Gửi lúc')} width={160}></Column>
                        <Column dataField="send_mail_invite_by" caption={translate('Gửi bởi')} width={160}></Column>
                    </Column>
                    <Column caption={translate('Email mời ghi danh')} alignment="center">
                        <Column dataField="is_send_mail_moi_ghi_danh" caption={translate('Đã gửi')} width={160}></Column>
                        <Column dataField="send_mail_moi_ghi_danh_at" dataType="date" format="dd/MM/yyyy HH:mm" caption={translate('Gửi lúc')} width={160}></Column>
                        <Column dataField="send_mail_moi_ghi_danh_by" caption={translate('Gửi bởi')} width={160}></Column>
                    </Column>
                </Column> */}
                <Sorting mode="multiple" />
                <Paging defaultPageSize={50} />
                {/* <Selection mode="single"></Selection> */}
                <FilterRow visible={true} />
                <FilterPanel visible={false} />
                <HeaderFilter visible={false} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 200, 500]}
                    infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                        'dòng'
                    )})`}
                    showInfo={true}
                />
            </DataGrid>
        </div>
    );
};

export default DetailGrid;